jQuery(($) => {
  function formatArgentinianPhoneNumber(input) {
    // Remove all non-numeric characters
    const cleaned = input.replace(/\D/g, "");

    // Check if the number starts with +54 or 54, otherwise assume it's missing
    const startsWithCountryCode =
      cleaned.startsWith("54") || cleaned.startsWith("+54");
    let phone = startsWithCountryCode ? cleaned.replace(/^\+?54/, "") : cleaned;

    // Validate length (must be between 10 and 13 digits)
    if (phone.length < 10 || phone.length > 13) {
      throw new Error("Invalid phone number length for Argentina.");
    }

    // Format the phone number
    const areaCodeLength =
      phone.length === 10 ? 2 : phone.length === 11 ? 3 : 4; // Adjust based on number length
    const areaCode = phone.slice(0, areaCodeLength);
    const mainNumber = phone.slice(areaCodeLength);

    // Ensure the number is in the format +54 (areaCode) number
    const formattedNumber = `+54 (${areaCode}) ${mainNumber.replace(
      /(\d{4})(\d{2,4})$/,
      "$1-$2"
    )}`;

    return formattedNumber;
  }

  // Extend WooCommerce's phone validation
  $(document.body).on(
    "input validate change",
    ".validate-phone input",
    function (e) {
      const $this = $(this);
      const $parent = $this.closest(".form-row");

      // Skip if empty (required validation will handle this)
      if (!$this.val()) return;

      try {
        // Try to format the number
        const formattedNumber = formatArgentinianPhoneNumber($this.val());

        // If we get here, validation passed
        $parent
          .removeClass("woocommerce-invalid woocommerce-invalid-phone")
          .addClass("woocommerce-validated");

        // Optionally update the field with formatted number
        $this.val(formattedNumber);
      } catch (error) {
        // Invalid phone number
        $parent
          .removeClass("woocommerce-validated")
          .addClass("woocommerce-invalid woocommerce-invalid-phone");
      }
    }
  );

  $(document.body).on(
    "updated_checkout payment_method_selected init_checkout payment_method_loaded fc_payment_methods_loaded",
    function (e) {
      console.log("Payment event triggered:", e.type);

      if (e.type !== "updated_checkout") {
        return;
      }

      // Get the billing email value
      const userEmail = $("#billing_email").val();

      // Only set if email exists and is not empty
      if (userEmail) {
        $(".payment_method_mercadopago-basic #kmp_email").val(userEmail);
        $(".payment_method_mercadopago-basic #kmp_reference_field").hide();
      }
    }
  );
});
